import { ValidationStatus } from '../../../../../../../views/marketing/followers/import';

export default {
  status: {
    [ValidationStatus.Valid]: {
      title: '¡Tu importación está casi lista!',
      description: 'Haz clic en continuar para completar la importación',
    },
    [ValidationStatus.HasInvalidContent]: {
      title: 'Algunos datos del archivo faltan o tienen formato incorrecto',
      description:
        'Por favor, corrige los errores a continuación y vuelve a subir el archivo, o continúa para ignorar las filas/celdas no válidas',
    },
    [ValidationStatus.Invalid]: {
      title: 'El archivo subido no puede procesarse',
      description: 'Por favor, corrige los errores a continuación e inténtalo de nuevo',
    },
  },
  sections: {
    heading_validation: {
      title: 'Se detectó una discrepancia en los nombres/orden de columnas:',
      rules: {
        Exact: 'La columna #{{column}} debe estar presente y llamarse exactamente <strong>{{expected}}</strong>',
      },
    },
    content_validation: {
      title: 'Se detectaron los siguientes errores:',
      labels: {
        row: 'Fila <strong>#{{row}}:</strong>',
        imported_rows_one: 'Se importará {{count}} fila',
        imported_rows_other: 'Se importarán {{count}} filas',
        ignored_rows_one: 'Se ignorará {{count}} fila',
        ignored_rows_other: 'Se ignorarán {{count}} filas',
      },
      fields: {
        email: 'Correo electrónico',
        phone_number: 'Número de teléfono',
        first_name: 'Nombre',
        last_name: 'Apellido',
        birthday: 'Cumpleaños',
      },
      rules: {
        Required: 'El campo {{field}} es obligatorio. La fila será ignorada',
        Email: 'Se espera que el campo {{field}} sea una dirección de correo válida. La fila será ignorada',
        Phone:
          'Se espera que el campo {{field}} sea un número de teléfono en formato internacional. El campo será ignorado',
        Date: 'Se espera que el campo {{field}} sea una fecha válida. El campo será ignorado',
      },
    },
  },
  buttons: {
    back_to_upload: 'Volver a subir',
    proceed: 'Continuar',
  },
  toasts: {
    error: 'Algo salió mal, por favor contacta al soporte',
  },
};
